import { Dispatch, SetStateAction, useState, useCallback, useEffect } from 'react'
import prop from 'ramda/es/prop'

import { api } from 'app/api'
import { GET_COMPLEX_PHOTO } from 'app/common/api/requests/food/menu/complex_photo'


type Options = {
  orgId: string
  complexId: string
  buildingId?: number // вариант для корпуса
  dietFoodTypeId?: number // опционально, вариант вида диет. питания
  date: string
}

type UsePhotoState = [string, Dispatch<SetStateAction<string>>]

export default function usePhoto(
  { orgId, complexId, buildingId, dietFoodTypeId, date }: Options,
  updatePhotoKey: any,
): UsePhotoState {
  const state = useState<string>('')
  const [, setImage] = state

  const requestPhoto = useCallback(async () => {
    const res = await api.request(GET_COMPLEX_PHOTO, {
      error: `Не удалось получить фотографию для комплекта ${complexId}`,
      params: {
        school_id: orgId,
        complex_id: [complexId],
        building_id: buildingId,
        diet_food_type_id: dietFoodTypeId,
        date,
      },
    })
    if (res) {
      setImage(prop(complexId, res) || '')
    }
  }, [orgId, complexId, buildingId, dietFoodTypeId, date, setImage])

  useEffect(() => {
    requestPhoto()
  }, [requestPhoto, updatePhotoKey])

  return state
}
